import SessionManager, { TOKEN_COOKIE, USER_COOKIE } from "./sessionManager";

// The login token is a JWT whose "sub" is a JSON string containing the real userId
// e.g. {"firstName":"Akash Gosavi","userId":1073,...}. It is the source of truth.
const tokenUserId = (token) => {
    try {
        const payload = String(token).replace(/^Bearer\s+/i, '').split('.')[1];
        const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        const sub = typeof json.sub === 'string' ? JSON.parse(json.sub) : json.sub;
        return sub?.userId ?? null;
    } catch {
        return null;
    }
};

// Logged-in customer saved at login in the customer cookie ({ userId, userName }).
// Returns null when the cookie does not belong to the token's user, so another
// customer's data can never be requested with this session.
export const getUser = () => {
    const token = SessionManager.getCookie(TOKEN_COOKIE);
    const cookieUser = SessionManager.getCookie(USER_COOKIE);
    try {
        const user = cookieUser ? JSON.parse(cookieUser) : null;
        if (!token || !user) return null;
        const fromToken = tokenUserId(token);
        if (fromToken !== null && String(fromToken) !== String(user.userId)) return null;
        return user;
    } catch {
        return null;
    }
};

export const getCustId = () => getUser()?.userId;

// Valid only when both cookies exist and agree with each other
export const isLoggedIn = () => !!getUser();

export const authHeader = () => ({
    "Content-Type": "application/json",
    // login returns the token with the "Bearer " prefix already included
    "Authorization": SessionManager.getCookie(TOKEN_COOKIE),
});
